
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gqtK7w7nb8CUJtEUZG8x_KJG6C0rPFrgvC_45EOliDENPAMeta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indextIvqIbiiY6VJJYJ4itLTKAXY0W_45vuJXUDUV1eFz6qZYMeta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search8e1ryNffPaz2ZHxXhvi8b53jVAYVGP_45sYr24z6Nd4_gMeta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexIjC_iLiLUnHO_455JK9obDvQtlr2RiuJIQvMiHxCxiAxQMeta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93MN7qs0yq08PBwMfHynnxuWjFH72_4zhfTr8izMO2HFAMeta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexdRrJ8_mQP6kWZrqRzsJVPTrv98zOrjXQmvysYYq_Qz8Meta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93BiUhcw_OaNBso_451i65155l21bo2uGto1d5uj4Vw3BTkMeta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexx2_vmvw_CTGvn675Ns03HUGIzvFTrxcA0AwwrHSzGlwMeta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93p1vI5LI6NI8wQ8_45P9jGVmlnd1IaJRXwy9XlGf9Z8xVYMeta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexmt9VlyL8Zy5U3_459oNSDGCV2uFPa7UhCE5frbPCApnqgMeta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index8vdM21aYs5GkzpOQFaXOJMlXRNiX1BYzewnLQPavqI8Meta } from "/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexdRrJ8_mQP6kWZrqRzsJVPTrv98zOrjXQmvysYYq_Qz8Meta || {},
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexx2_vmvw_CTGvn675Ns03HUGIzvFTrxcA0AwwrHSzGlwMeta || {},
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexmt9VlyL8Zy5U3_459oNSDGCV2uFPa7UhCE5frbPCApnqgMeta || {},
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index8vdM21aYs5GkzpOQFaXOJMlXRNiX1BYzewnLQPavqI8Meta || {},
    component: () => import("/codebuild/output/src2846360425/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]